import { h } from 'preact'
import { tagParser, updateCSSVarScrollbarWidth } from '../../js/modules/utilities'
import smallLogo from './small-logo-orange.svg'
import logo from './logo-orange.png'
import { useEffect } from 'preact/hooks'

export const StratMarque = ({ title, items, analytics }) => {
   useEffect(() => {
      updateCSSVarScrollbarWidth()
   }, [])
   
   return (
      <div class="strat-marque pt-2 bg-dark text-white mt-3 mt-lg-2 mt-xl-3" data-pdb-zid={analytics.pdbZid}>
         <div class="container-fluid">
            <div class="d-flex justify-content-between">
               <h2 class="no-signature mr-2" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></h2>
               <picture>
                  <source srcset={smallLogo} media="(max-width: 479.98px)" />
                  <img class="logo" src={logo} alt="" loading="lazy" />
               </picture>
            </div>

            <div class="row">
               <div class="col-12 col-md-10">
                  <ul class="row list-unstyled">
                     {items.map(({ icon, label }, index) => (
                        <li class="col-12 col-md-6" key={index}>
                           <p class="label lead mb-1 mb-md-2">
                              <span class={`icon icon-${icon} mr-2`}></span>
                              <span>{label}</span>
                           </p>
                        </li>
                     ))}
                  </ul>
               </div>
            </div>
         </div>
      </div>
   )
}
